<template>
  <div class="tc">
    <div class="loading_img pr">
      <img class="loading_bg pa" src="./img/bg.png" />
      <img class="loading_icon pa" src="./img/icon.png" />
    </div>
    <div class="fw500 fs20">您的信息正在认证中…</div>
    <div class="mt20 pt10 fs14">根据已提交的资料，正在为您重新评估额度</div>

    <div class="loading_info fs14 tl pr">
      <div class="flex ai_c">
        <img src="./img/icon_1.png" />
        <div class="ml10">
          <div>申请额度</div>
          <div class="c8a8 fs12 mt10">收到您的额度申请</div>
        </div>
      </div>
      <div class="flex mt40 ai_c">
        <img src="./img/icon_1.png" />
        <div class="ml10">
          <div>身份信息</div>
          <div class="c8a8 fs12 mt10">合适您的身份信息</div>
        </div>
      </div>
      <div class="flex mt40 ai_c">
        <img src="./img/icon_2.png" />
        <div class="ml10 c8a8">
          <div>补充资料</div>
          <div class="fs12 mt10">根据资料为您匹配、产品</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as API_Common from "@/api/common.js";
import { toRedirectUrlAndSaveRecordNoDebounce } from "@/api/common.js";
import Cookies from "js-cookie";
import "@/assets/styles/base_new.scss";
export default {
  name: "stateWatingModel8Nwd",
  data() {
    return {
      source: "",
      code: this.$route.query.code,
      persent: 0,
      step: 1,
      currentRate: 0,
      rate: 0,
      timer: null,
      second: 0,
      minute: 0,
      unionToken: this.$route.query.token,
      apiProduct: {
        imgUrl: "",
        thirdPartyId: "",
        productId: "",
        companyName: "",
        name: "",
        userId: "",
        content: "",
        redirectUrl: "",
        grantValue: "",
        grantApiLists: [],
      },
      recommendProduct: {},
      unionLogin: {
        productId: 0,
        url: "",
      },
    };
  },
  mounted() {
    this.initState();
    this.autoToHref();
    window.localStorage.removeItem("cytClosePop");
    this.source = this.$route.query.source;
    if (this.unionToken) {
      console.log("unionToken:" + this.unionToken);
      this.getUnionToken(this.unionToken);
    }
  },

  methods: {
    //API机构和授权书
    async getAPIProduct() {
      const model = sessionStorage.getItem("model");
      if (model === "model14") {
        //海尔渠道单独处理
        this.$router.replace({
          name: "stagingAssessmentModelHaier",
          query: { source: this.source },
        });
        return;
      }
      try {
        const res = await API_Common.getProductByUserV2(this.source);
        if (res?.data?.api.length) {
          this.$router.replace({
            name: "matchingResults_nwd",
            query: { source: this.source },
          });
        } else {
          const isBiddingItem = res.data.cpa?.find((e) => e.isBidding == 1);
          if (isBiddingItem) {
            localStorage.setItem("bidding_item", JSON.stringify(isBiddingItem));
            this.$router.replace({
              name: "matchingResults_cpa",
              query: { source: this.source },
            });
            return false;
          }
          if (this.source === "7CUYBjpWop") {
            //微博渠道直接跳转
            this.handlePushApiResult();
          } else {
            this.getChannleProductList();
          }
        }
      } catch (error) {
        this.handlePushApiResult();
      }
    },
    // 根据渠道code读取产品推荐信息 将权重最大的进行显示
    getChannleProductList() {
      API_Common.getChannleProductList(this.source).then((res) => {
        if (res.code === 200) {
          let dataArr = res.data;
          if (dataArr.length > 0) {
            this.recommendProduct = dataArr[0];
            this.handleProductResult();
          } else {
            this.handlePushApiResult();
          }
        } else {
          this.handlePushApiResult();
        }
      });
    },
    //根据返回不同的产品类型 调用不同接口
    handleProductResult() {
      let redirectUrl = this.recommendProduct.linkUrl; // 默认跳转 URL
      let isWeCom = this.recommendProduct.isWeCom;
      let userId = window.localStorage.getItem("userId");
      const buriedData = {
        channel: this.source,
        userId: userId,
        productId: this.recommendProduct.id,
        showPage: 5,
      };
      if (this.recommendProduct.isToRegister === 1) {
        API_Common.getRegister2CompanyUrl(
          this.recommendProduct.id,
          this.recommendProduct.hitRecordId
        )
          .then(async (res) => {
            await this.handlePushApiResult();
            if (res.code === 200 && res.data) {
              redirectUrl = res.data;
            } else {
              console.warn("getRegister2CompanyUrl 返回数据异常，使用默认 URL");
            }
          })
          .catch(async (error) => {
            await this.handlePushApiResult();
          })
          .finally(() => {
            //无论api成功或者失败 都执行跳转和埋点
            toRedirectUrlAndSaveRecordNoDebounce(
              redirectUrl,
              buriedData,
              isWeCom
            );
          });
      } else if (this.recommendProduct.isToRegister === 3) {
        var that = this;
        API_Common.getUnionLogin4ClickV3(
          that.recommendProduct.id,
          that.recommendProduct.hitRecordId
        )
          .then(async (res) => {
            await that.handlePushApiResult();
            that.unionLogin = res.data;
          })
          .catch(async (error) => {
            await that.handlePushApiResult();
          })
          .finally(() => {
            toRedirectUrlAndSaveRecordNoDebounce(
              that.unionLogin.url,
              {
                channel: that.source,
                userId: userId,
                productId: that.recommendProduct.id,
                showPage: 5,
              },
              isWeCom
            );
          });
      } else {
        this.handlePushApiResult();
      }
    },
    getUnionToken(unionToken) {
      API_Common.getUnionToken(unionToken).then((res) => {
        if (res.code === 200) {
          Cookies.set("token", res.data.token);
          window.localStorage.setItem("userId", res.data.userId);
        } else {
          this.$toast(res.msg);
        }
      });
    },
    handlePushApiResult() {
      const routeName =
        this.source === "paipai4" ? "capResults" : "auditResult_nwd";
      this.$router.replace({
        name: routeName,
        query: { source: this.source },
      });
    },
    initState() {
      var that = this;
      var intervalFunc = setInterval(function () {
        if (that.persent === 99) clearInterval(intervalFunc);
        that.persent++;
        that.modifyTxt(that.persent);
        that.persentWidth++;
      }, 35);
    },
    autoToHref() {
      var that = this;
      setTimeout(function () {
        that.getAPIProduct();
      }, 4000);
    },

    modifyTxt(num) {
      switch (num) {
        case 0:
          this.step = 1;
          break;
        case 33:
          this.step = 2;
          break;
        case 100:
          this.step = 3;

          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.mt40 {
  margin-top: 0.8rem;
}
.loading_img {
  width: 2rem;
  height: 2rem;
  background: #fff;
  box-shadow: 0 0 0.22rem 0 rgba(214, 214, 214, 0.36);
  border-radius: 2rem;
  margin: 1.48rem auto 0.76rem;
  .loading_icon {
    width: 1.12rem;
    top: 0.44rem;
    left: 0.44rem;
  }
  .loading_bg {
    width: 2rem;
    left: 0;
    top: 0;
    animation: loading_img 1s linear infinite;
  }
}
.loading_info {
  margin: 1.36rem 0 0.6rem 2.56rem;
  img {
    width: 0.32rem;
  }
  &::after,
  &::before {
    content: "";
    position: absolute;
    height: 0.88rem;
    width: 0.02rem;
    background: linear-gradient(180deg, #f7f9ff 0%, #c9ccd6 100%);
    left: 0.16rem;
    top: 0.64rem;
  }
  &::before {
    top: 2.16rem;
  }
}

@keyframes loading_img {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
